<template>
  <div class="enterprise-value">
    <div
      v-for="(item, index) in enterprise"
      :key="index"
      class="cell"
    >
      <span>{{item}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enterprise: Array
  }
}
</script>

<style scoped>
.enterprise-value {
  height: 35vh;
  overflow: hidden;
  color: #fff;
  text-align: left;
  padding-left: 15%;
  box-sizing: border-box;
  padding-right: 5%;
}
.enterprise-value .cell {
  height: 8.33%;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.enterprise-value .cell span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
